class cfJSClass {
    /*
    * return element by id
    */
    byId(id) {
        return document.getElementById(id);
    }
    /*
    * style set function
    */
    style(dom, styles, value) {
        try {
            if (dom && styles && !value)
                if (typeof styles === "string") {
                    return dom.style[styles]
                } else {
                    for (let i in styles)
                        dom.style[i] = styles[i];
                }

            if (dom && styles && value)
                dom.style[styles] = value;
        } catch (e) {
            console.log("Error Engine.style: " + e);
        }
    }
    /*
    *
    */
    querySelector(dom,selector) {
        if (String(selector).substr(0,1)==">") {
            let isBeId = false;
            if (!dom.id)
                dom.id = "selector_id_fixed";
            else
                isBeId = true;

            let result = dom.querySelector("#"+dom.id+selector);

            if (!isBeId)
                dom.removeAttribute("id");

            return result;
        } else
            return dom.querySelector(selector);
    }
    /*
    *
    */
    querySelectorAll(dom,selector) {
        if (String(selector).substr(0,1)==">") {
            let isBeId = false;
            if (!dom.id)
                dom.id = "selector_id_fixed";
            else
                isBeId = true;

            let result = dom.querySelectorAll("#"+dom.id+selector);

            if (!isBeId)
                dom.removeAttribute("id");

            return result;
        } else
            return dom.querySelectorAll(selector);
    }
    /*
    * add listener to dom-element
    */
    addListener(dom, event, func) {
        if (!dom) {
            console.warn("cfJS (addListener): Element not found", dom, new Error().stack);
            return;
        }

        let headerClass = {
            connect: function () {
                dom.addEventListener(event, func, false);
            },
            disconnect: function () {
                if (dom.removeEventListener) {
                    dom.removeEventListener(event, func);
                } else if (dom.detachEvent) { // For IE 8 and earlier versions
                    dom.detachEvent(event, func);
                }
            }
        };

        headerClass.connect();
        headerClass.connect = null;

        return headerClass;
    }
}

const cfJS = new cfJSClass();

export default cfJS;